import dataSelect from '@store/dataForSelect/reducers';

import { setting_category_select } from '../../configs/constants';

export default dataSelect(setting_category_select);
